<div style="text-align:center; margin:auto; padding:30px; width:300px; font-size:16px; color:#797979;">
	<form #emailForm="ngForm" (ngSubmit)="updateEmail(emailForm);">
		<div *ngIf="msgType==='noEmail'">
			Looks like you have subscribed to the report but have removed your email address from your profile. Enter your email below to continue to receive the monthly report from {{name}}.
		</div>
		<div *ngIf="msgType!=='noEmail'">
			Looks like we don't have your email address. Please enter your email address so we can subscribe you to {{name}} meterics report.
		</div>
		<input type="email" name="myEmail" ngModel required class="form-control" placeholder="Enter Email Address" autocomplete="off" maxlength="150" style="width:100%; margin:20px 0px;" />
		<div *ngIf="emailInvalid" style="color:red; margin:20px 0px;">
			Email format is incorrect. Please review.
		</div>
		<button type="submit" class="btn btn-primary" [disabled]="!emailForm.valid">Submit</button>
		<button type="button" class="btn btn-outline-primary" (click)="cancel()" style="margin-left:40px;">Cancel</button>
	</form>
</div>
